import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { ViewColumnComponent } from '../../../../..//view-column.component';
import { SubSink } from 'subsink2';
import { BranchSettingsFacade } from '../../../facades/branch-settings.facade';
import { BranchSettingsSelectors } from '../../../branch-settings-controller/selectors';
import { BranchSettingsActions} from '../../../branch-settings-controller/actions';
import { BranchSettingsStates } from '../../../branch-settings-controller/states';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../../../..//visa';
import { of, iif, EMPTY } from "rxjs";
import { delay, mergeMap } from 'rxjs/operators';

interface LocalState {
  deactivateAdd: boolean;
  deactivateReturn: boolean;
  selectedIndex: number;
  deleteConfirmation: boolean;
}
export interface EditAttachment {
  id?: string;
  file: File;
  fileSRC: string | ArrayBuffer;
  fileAttributes: {
      fileName: string
      size: string
  }
}
@Component({
  selector: 'app-branch-printable-image-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [ComponentStore]
})

export class BranchPrintableImageEditComponent extends ViewColumnComponent {

  protected subs = new SubSink();

  protected compName = 'Edit Branch Printable Image';
  protected index = 8;
  protected localState: LocalState;
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deleteConfirmation$ = this.componentStore.select(state => state.deleteConfirmation);

  apiVisa = AppConfig.apiVisa;
  byteSize = ['Bytes', 'KB', 'MB'];
  attachment: EditAttachment;
  imageUrl;
  uploadedFile;
  branchGuid;
  form: FormGroup;
  src : any;
  guid;
  deleteConfirmation = false;
  @ViewChild(MatTabGroup) matTab: MatTabGroup;

  constructor(
    private http: HttpClient,
    private branchSettingsStore: Store<BranchSettingsStates>,
    protected viewColFacade: BranchSettingsFacade,
    protected readonly componentStore: ComponentStore<LocalState>
    ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectBranch).subscribe(b=>{
      this.branchGuid = b.guid;
    })
    this.subs.sink = this.localState$.subscribe( a => {
      this.localState = a;
      this.componentStore.setState(a);
    });

    this.form = new FormGroup({
      imageCode: new FormControl(),
      imageName: new FormControl()
    })

    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectPrintableImage).subscribe(async (resolved: any) => {
      console.log(resolved);
      const propertyJson = <any>resolved.acl_config;
      this.guid = resolved.guid;
      this.imageUrl = this.apiVisa.api_domain_url + 'core2/tnt/dm/prt/printable-format/image-hdrs/backoffice-ep/pub/file/' + this.guid + '?tenantCode=' + this.apiVisa.tenantCode;
      this.src = await this.downloadImage(propertyJson?.file_name);

      this.form.patchValue({
        imageCode: resolved.image_code,
        imageName: resolved.image_name
      });

      this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectPrintableImageFile).subscribe(file=>{
        this.uploadedFile = file
      })


      const newAttributes = propertyJson;
      this.updateFileAttributes(newAttributes);
      console.log('this.attachment ',this.attachment )
    });
    this.subs.sink = this.deleteConfirmation$.pipe(
      mergeMap(a => {
        return iif(() => a, of(a).pipe(delay(3000)), of(EMPTY));
      })
    ).subscribe(resolve => {
      if (resolve === true) {
        this.componentStore.patchState({deleteConfirmation: false});
        this.deleteConfirmation = false;
      }
    });
  }

  async downloadImage(fileName: string) {
    const Authorization = localStorage.getItem('authToken');
    const headers = new HttpHeaders({ Authorization });
    const imageBlob = await this.http
      .get(this.imageUrl, { headers, responseType: 'blob' })
      .toPromise();
    const reader = new FileReader();
    console.log("Image Blob",imageBlob);

    if(imageBlob.size!==0){
      return await new Promise<string>((resolve, reject) => {
        console.log("Data Image", resolve);
        reader.onloadend = () => setTimeout(resolve,2000,reader.result as string);
        reader.readAsDataURL(imageBlob);
        this.uploadedFile = new File([imageBlob], fileName, { type: imageBlob.type });
      })
    }else{
      return null;
    }
  }

  onChange(e: FileList) {
    let attachment: EditAttachment;
    Object.values(e).forEach(file => {
      let size = file.size, sizeIncrement = 0;
      while (size >= 1024) {
        size /= 1024;
        sizeIncrement++;
      }
      const fileReader = new FileReader();

      fileReader.readAsDataURL(file);
      fileReader.addEventListener('loadend', (a) => {
        attachment = {
          file,
          fileSRC: file.type.includes('image') ? a.target.result : 'icon',
          fileAttributes: {
            fileName: file.name,
            size: `${sizeIncrement > 0 ? size.toFixed(2) : size} ${this.byteSize[sizeIncrement]}`
          }
        }
        this.attachment = attachment;
        this.uploadedFile = file;
      });
    });
  }

  disableSave() {
    let result = false;
    if(!this.attachment){
      result = true;
    }
    if(this.form.invalid){
      result = true;
    }
    if(this.attachment &&
      (this.attachment.fileAttributes.fileName.endsWith('.jpg')
    || this.attachment.fileAttributes.fileName.endsWith('.png')
    || this.attachment.fileAttributes.fileName.endsWith('.jpeg')
    || this.attachment.fileAttributes.fileName.endsWith('.gif')
    )){
      result = false;
    }else{
      result = true;
    }

    return result;
  }

  onDeleteFile() {
    this.attachment = null
  }

  onReturn(){
    this.viewColFacade.onPrev(1);
  }

  onSave() {
    const data = {
      "file": this.uploadedFile,
      "attachment": this.attachment,
      "imageCode": this.form.value.imageCode,
      "imageName": this.form.value.imageName
    }
    console.log('data',data);
    this.branchSettingsStore.dispatch(BranchSettingsActions.editPrintableImageInit({ data }));
  }

  updateFileAttributes(propertyJson: any) {
    // Ensure this.attachment is initialized
    if (!this.attachment) {
      this.attachment = {
        file: null as any, // Initialize with a placeholder value; replace with your logic
        fileSRC: '',
        fileAttributes: { fileName: '', size: '' },
      };
    }

    // Update fileAttributes
    this.attachment.fileAttributes = propertyJson;
  }

  onDelete(){
    if (this.deleteConfirmation) {
      this.branchSettingsStore.dispatch(BranchSettingsActions.deletePrintableImageInit({guid: this.guid}));
      this.deleteConfirmation = false;
      this.componentStore.patchState({deleteConfirmation: false});
    } else {
      this.deleteConfirmation = true;
      this.componentStore.patchState({deleteConfirmation: true});
    }
  }
}
